<script setup lang="ts">
import AngleLeftSmall from '~icons/cue-filled/angle-left-small'

withDefaults(
  defineProps<{
    label?: string
    company?: string
    logoSrc?: string
    hideCompany?: boolean
    back?: string
  }>(),
  {
    label: '',
    company: '',
    logoSrc: '',
    hideCompany: false,
    back: '',
  },
)

defineEmits(['back'])
</script>

<template lang="pug">
.header.p-16-16-15.flex.row-16.z-index-10(:class="{ 'flex-center-center': !back && !label }")
  NuxtLink.icon-back.flex-center-center.p-11.br-14.size-44.flex-shrink-0.cursor-pointer(v-if="!hideCompany && back" :to="back" @click="$emit('back')")
    UiIcon.s-20(:name="AngleLeftSmall")
  .title.flex-center-center.typ-16-44-500.w-100p(v-if="label") {{ $t(label) }}
  UiImage.size-44(v-if="!hideCompany" :src="logoSrc")
  .title.typ-20-28-600.w-100p(v-if="company") {{ company }}
</template>

<style scoped>
.header {
  position: sticky;
  border-radius: 24px 24px 0 0;

  @screen md {
    border-bottom: 1px solid var(--cue-border-neutral-primary);
  }
}

.title {
  color: var(--cue-content-neutral-primary);
}

.icon-back {
  border: 1px solid var(--cue-border-neutral-secondary);
  background: none;
  color: var(--cue-content-neutral-primary);
}
</style>
